// بيانات الصيانة (أمثلة للسوفتوير)
export const ordersData = [
  {
    id: "2050",
    clientName: "رياض سوفت",
    device: "Samsung S23 Ultra",
    problem: "FRP Bypass (Android 14)",
    status: "جاري العمل",
    cost: "2500 DZD"
  },
  {
    id: "2051",
    clientName: "أمين حاسوب",
    device: "Dell Latitude 5490",
    problem: "تثبيت ويندوز 11 + تفعيل",
    status: "جاهز للاستلام",
    cost: "1500 DZD"
  },
  {
    id: "2052",
    clientName: "سارة",
    device: "iPhone 12",
    problem: "iCloud Bypass (Signal)",
    status: "قيد الانتظار",
    cost: "6000 DZD"
  }
];

// منتجات المتجر (حواسيب وخدمات)
export const productsData = [
  {
    id: 1,
    name: "خدمة تخطي FRP (سامسونج)",
    price: 1500,
    category: "Unlock Services",
    image: "🔓"
  },
  {
    id: 2,
    name: "Laptop HP EliteBook G5",
    price: 58000,
    category: "Computers",
    image: "💻"
  },
  {
    id: 3,
    name: "تفعيل سيرفر Chimera (سنة)",
    price: 22000,
    category: "Servers",
    image: "🌍"
  },
  {
    id: 4,
    name: "خدمة فتح iCloud (Clean)",
    price: 18000,
    category: "Unlock Services",
    image: "☁️"
  },
  {
    id: 5,
    name: "Windows 11 Pro Key",
    price: 2500,
    category: "Software",
    image: "🪟"
  },
  {
    id: 6,
    name: "MacBook Pro 2019",
    price: 125000,
    category: "Computers",
    image: "🍎"
  }
];